const actions = {
  GET_PAYCONSTRUCT_PRODUCTS: 'GET_PAYCONSTRUCT_PRODUCTS',
  GET_PAYCONSTRUCT_PRODUCTS_SUCCESS: 'GET_PAYCONSTRUCT_PRODUCTS_SUCCESS',
  GET_PAYCONSTRUCT_PRODUCTS_FAILURE: 'GET_PAYCONSTRUCT_PRODUCTS_FAILURE',

  GET_PAYMERO_PRODUCTS: 'GET_PAYMERO_PRODUCTS',
  GET_PAYMERO_PRODUCTS_SUCCESS: 'GET_PAYMERO_PRODUCTS_SUCCESS',
  GET_PAYMERO_PRODUCTS_FAILURE: 'GET_PAYMERO_PRODUCTS_FAILURE',

  // GET_PRODUCTS: 'GET_PRODUCTS',
  // GET_PRODUCTS_SUCCESS: 'GET_PRODUCTS_SUCCESS',
  // GET_PRODUCTS_FAILURE: 'GET_PRODUCTS_FAILURE',

  UPDATE_PREFFERED_COMMUICATION_LIST: 'UPDATE_PREFFERED_COMMUICATION_LIST',

  GET_CUSTOMER_DETAILS: 'GET_CUSTOMER_DETAILS',
  GET_CUSTOMER_DETAILS_SUCCESS: 'GET_CUSTOMER_DETAILS_SUCCESS',
  GET_CUSTOMER_DETAILS_FAILURE: 'GET_CUSTOMER_DETAILS_FAILURE',

  UPDATE_CUSTOMER_DETAILS: 'UPDATE_CUSTOMER_DETAILS',
  UPDATE_CUSTOMER_DETAILS_SUCCESS: 'UPDATE_CUSTOMER_DETAILS_SUCCESS',
  UPDATE_CUSTOMER_DETAILS_FAILURE: 'UPDATE_CUSTOMER_DETAILS_FAILURE',

  UPDATE_PREQUALIFICATION_DETAILS: 'UPDATE_PREQUALIFICATION_DETAILS',
  // SELECTED_PAYCONSTRUCT_PRODUCTS: 'SELECTED_PAYCONSTRUCT_PRODUCTS',
  SELECTED_PAYMERO_PRODUCTS: 'SELECTED_PAYMERO_PRODUCTS',

  // handling input form data's
  UPDATE_USER_INPUT_DATA_REGISTER: 'UPDATE_USER_INPUT_DATA_REGISTER',
  UPDATE_USER_INPUT_DATA_LOGIN: 'UPDATE_USER_INPUT_DATA_LOGIN',
  UPDATE_USER_INPUT_DATA_RESET_PASSWORD: 'UPDATE_USER_INPUT_DATA_RESET_PASSWORD',
  LOCATION_CHANGE: '@@router/LOCATION_CHANGE',

  // risk qualification

  UPDATE_REGULATORY_DETAILS: 'UPDATE_REGULATORY_DETAILS',

  GET_OPERATION_QUESTIONS: 'GET_OPERATION_QUESTIONS',
  GET_OPERATION_QUESTIONS_SUCCESS: 'GET_OPERATION_QUESTIONS_SUCCESS',
  GET_OPERATION_QUESTIONS_FAILURE: 'GET_OPERATION_QUESTIONS_FAILURE',

  GET_REGULATORY_QUESTIONS: 'GET_REGULATORY_QUESTIONS',
  GET_REGULATORY_QUESTIONS_SUCCESS: 'GET_REGULATORY_QUESTIONS_SUCCESS',
  GET_REGULATORY_QUESTIONS_FAILURE: 'GET_REGULATORY_QUESTIONS_FAILURE',

  GET_NEXT_REGULATORY_QUESTION: 'GET_NEXT_REGULATORY_QUESTION',
  GET_NEXT_REGULATORY_QUESTION_SUCCESS: 'GET_NEXT_REGULATORY_QUESTION_SUCCESS',
  GET_NEXT_REGULATORY_QUESTION_FAILURE: 'GET_NEXT_REGULATORY_QUESTION_FAILURE',

  UPDATE_SELECTED_LICENSE_TYPE: 'UPDATE_SELECTED_LICENSE_TYPE',

  GET_REGULATORY_COUNTRIES: 'GET_REGULATORY_COUNTRIES',
  GET_REGULATORY_COUNTRIES_SUCCESS: 'GET_REGULATORY_COUNTRIES_SUCCESS',
  GET_REGULATORY_COUNTRIES_FAILURE: 'GET_REGULATORY_COUNTRIES_FAILURE',

  GET_EU_COUNTRIES: 'GET_EU_COUNTRIES',
  GET_EU_COUNTRIES_SUCCESS: 'GET_EU_COUNTRIES_SUCCESS',
  GET_EU_COUNTRIES_FAILURE: 'GET_EU_COUNTRIES_FAILURE',

  GET_GAMING_COUNTRIES: 'GET_GAMING_COUNTRIES',
  GET_GAMING_COUNTRIES_SUCCESS: 'GET_GAMING_COUNTRIES_SUCCESS',
  GET_GAMING_COUNTRIES_FAILURE: 'GET_GAMING_COUNTRIES_FAILURE',

  GET_FOREX_COUNTRIES: 'GET_FOREX_COUNTRIES',
  GET_FOREX_COUNTRIES_SUCCESS: 'GET_FOREX_COUNTRIES_SUCCESS',
  GET_FOREX_COUNTRIES_FAILURE: 'GET_FOREX_COUNTRIES_FAILURE',

  IS_EDIT_VIEW_REGULATORY_INFO_UPDATED: 'IS_EDIT_VIEW_REGULATORY_INFO_UPDATED',

  UPDATE_PASSWORD_STRENGTH: 'UPDATE_PASSWORD_STRENGTH',

  SHOW_CHANGE_PASSWORD_MODAL: 'SHOW_CHANGE_PASSWORD_MODAL',
  CLOSE_CHANGE_PASSWORD_MODAL: 'CLOSE_CHANGE_PASSWORD_MODAL',

  GET_DOCUMENTS_FILE: 'GET_DOCUMENTS_FILE',
  GET_DOCUMENTS_FILE_SUCCESS: 'GET_DOCUMENTS_FILE_SUCCESS',
  GET_DOCUMENTS_FILE_FAILURE: 'GET_DOCUMENTS_FILE_FAILURE',

  GET_PRESIGNED_URL: 'GET_PRESIGNED_URL',
  GET_PRESIGNED_URL_SUCCESS: 'GET_PRESIGNED_URL_SUCCESS',
  GET_PRESIGNED_URL_FAILURE: 'GET_PRESIGNED_URL_FAILURE',

  ADD_DOCUMENT_FILES: 'ADD_DOCUMENT_FILES',
  ADD_DOCUMENT_FILES_SUCCESS: 'ADD_DOCUMENT_FILES_SUCCESS',
  ADD_DOCUMENT_FILES_FAILURE: 'ADD_DOCUMENT_FILES_FAILURE',

  REMOVE_DOCUMENT_FILES: 'REMOVE_DOCUMENT_FILES',
  REMOVE_DOCUMENT_FILES_SUCCESS: 'REMOVE_DOCUMENT_FILES_SUCCESS',
  REMOVE_DOCUMENT_FILES_FAILURE: 'REMOVE_DOCUMENT_FILES_FAILURE',

  GET_DOCUMENTS_QUESTIONS: 'GET_DOCUMENTS_QUESTIONS',
  GET_DOCUMENTS_QUESTIONS_SUCCESS: 'GET_DOCUMENTS_QUESTIONS_SUCCESS',
  GET_DOCUMENTS_QUESTIONS_FAILURE: 'GET_DOCUMENTS_QUESTIONS_FAILURE',

  UPDATE_COUNTRIESLIST_BASED_ON_INDUSTRY_SELECT: 'UPDATE_COUNTRIESLIST_BASED_ON_INDUSTRY_SELECT',

  // ubos and directors

  ADD_UBO_DETAILS: 'ADD_UBO_DETAILS',
  CANCEL_UBO_DETAILS: 'CANCEL_UBO_DETAILS',

  UPDATE_UBO_DETAILS: 'UPDATE_UBO_DETAILS',
  UPDATE_SELECTED_EDIT_UBO: 'UPDATE_SELECTED_EDIT_UBO',

  DELETE_SELECTED_UBO: 'DELETE_SELECTED_UBO',

  GET_ALL_STAKEHOLDERS: 'GET_ALL_STAKEHOLDERS',
  GET_ALL_STAKEHOLDERS_SUCCESS: 'GET_ALL_STAKEHOLDERS_SUCCESS',
  GET_ALL_STAKEHOLDERS_FAILURE: 'GET_ALL_STAKEHOLDERS_FAILURE',

  ADD_COMPANY_STAKEHOLDER: 'ADD_COMPANY_STAKEHOLDER',
  ADD_COMPANY_STAKEHOLDER_SUCCESS: 'ADD_COMPANY_STAKEHOLDER_SUCCESS',
  ADD_COMPANY_STAKEHOLDER_FAILURE: 'ADD_COMPANY_STAKEHOLDER_FAILURE',

  EDIT_COMPANY_STAKEHOLDER: 'EDIT_COMPANY_STAKEHOLDER',
  EDIT_COMPANY_STAKEHOLDER_SUCCESS: 'EDIT_COMPANY_STAKEHOLDER_SUCCESS',
  EDIT_COMPANY_STAKEHOLDER_FAILURE: 'EDIT_COMPANY_STAKEHOLDER_FAILURE',

  DELETE_COMPANY_STAKEHOLDER: 'DELETE_COMPANY_STAKEHOLDER',
  DELETE_COMPANY_STAKEHOLDER_SUCCESS: 'DELETE_COMPANY_STAKEHOLDER_SUCCESS',
  DELETE_COMPANY_STAKEHOLDER_FAILURE: 'DELETE_COMPANY_STAKEHOLDER_FAILURE',

  UPDATE_TOTAL_PERCENTAGESHARES: 'UPDATE_TOTAL_PERCENTAGESHARES',

  // operation questions

  ADD_RC_OQ_BENE_DETAILS: 'ADD_RC_OQ_BENE_DETAILS',
  EDIT_RC_OQ_BENE_DETAILS: 'EDIT_RC_OQ_BENE_DETAILS',
  CANCEL_RC_OQ_BENE_DETAILS: 'CANCEL_RC_OQ_BENE_DETAILS',

  UPDATE_RC_OQ_BENE_DETAILS: 'UPDATE_RC_OQ_BENE_DETAILS',

  DELETE_SELECTED_RC_OQ_BENE: 'DELETE_SELECTED_RC_OQ_BENE',

  // restricted currencies

  ADD_RC_RM_DETAILS: 'ADD_RC_RM_DETAILS',
  EDIT_RC_RM_DETAILS: 'EDIT_RC_RM_DETAILS',
  CANCEL_RC_RM_DETAILS: 'CANCEL_RC_RM_DETAILS',

  UPDATE_RC_RM_DETAILS: 'UPDATE_RC_RM_DETAILS',

  DELETE_SELECTED_RC_RM: 'DELETE_SELECTED_RC_RM',

  UPDATE_RC_MARKETS_LIVE: 'UPDATE_RC_MARKETS_LIVE',

  // license

  ADD_LICENSE: 'ADD_LICENSE',
  EDIT_LICENSE: 'EDIT_LICENSE',
  CANCEL_LICENSE: 'CANCEL_LICENSE',

  UPDATE_LICENSE: 'UPDATE_LICENSE',
  DELETE_LICENSE: 'DELETE_LICENSE',

  // book a meeting
  OPEN_MODAL_BOOK_A_MEETING: 'OPEN_MODAL_BOOK_A_MEETING',
  CLOSE_MODAL_BOOK_A_MEETING: 'CLOSE_MODAL_BOOK_A_MEETING',
}

export default actions

export const updateCustomer = (id, values, token, module) => {
  return {
    type: actions.UPDATE_CUSTOMER_DETAILS,
    id,
    values,
    token,
    module,
  }
}

export const showChangePasswordModal = () => {
  return {
    type: actions.SHOW_CHANGE_PASSWORD_MODAL,
  }
}

export const closeChangePasswordModal = () => {
  return {
    type: actions.CLOSE_CHANGE_PASSWORD_MODAL,
  }
}

export const updatePassowrdStrength = value => {
  return {
    type: actions.UPDATE_PASSWORD_STRENGTH,
    value,
  }
}
